import { type AdapterConfigStatus } from "../../hooks/use-shell-connection";
import { getAdapterConfigStatusLabel } from "../../utils/status";
import { Button } from "../ui/button";

interface TroubleshootingPanelProps {
  selectedVersion: number | null;
  adapterConfigStatus: AdapterConfigStatus | null;
  hasAccessToken: boolean;
  onClose: () => void;
}

export function TroubleshootingPanel({
  selectedVersion,
  adapterConfigStatus,
  hasAccessToken,
  onClose,
}: Readonly<TroubleshootingPanelProps>): JSX.Element {
  return (
    <section
      className="border-b border-border bg-card px-4 py-3"
      aria-label="Troubleshooting details"
    >
      <div className="mb-2.5 flex items-center justify-between gap-2">
        <h2 className="m-0 text-sm font-bold text-foreground">Troubleshooting</h2>
        <Button type="button" variant="ghost" size="sm" onClick={onClose}>
          Close
        </Button>
      </div>
      <dl className="m-0 flex flex-col gap-2">
        <div className="flex flex-col gap-0.5">
          <dt className="text-xs font-semibold text-muted-foreground">
            Contract version
          </dt>
          <dd className="m-0 text-[0.8125rem] text-muted-foreground">
            v{selectedVersion ?? "unknown"}
          </dd>
        </div>
        <div className="flex flex-col gap-0.5">
          <dt className="text-xs font-semibold text-muted-foreground">
            Adapter config
          </dt>
          <dd className="m-0 text-[0.8125rem] text-muted-foreground">
            {getAdapterConfigStatusLabel(adapterConfigStatus)}
          </dd>
        </div>
        <div className="flex flex-col gap-0.5">
          <dt className="text-xs font-semibold text-muted-foreground">
            Token state
          </dt>
          <dd className="m-0 text-[0.8125rem] text-muted-foreground">
            {hasAccessToken ? "Available" : "Missing"}
          </dd>
        </div>
      </dl>
    </section>
  );
}
